import {getEventPageUrl} from '@wix/wix-events-commons-statics'
import React from 'react'
import {SocialBar as SocialBarCommons} from '../../../../../commons/components/social-bar'
import {getEventUrl} from '../../../../../commons/selectors/event'
import {isEventsInMembersInstalled} from '../../../../../commons/selectors/installed-apps'
import {useWidgetActions, useWidgetRuntimeContext, useWidgetState} from '../../hooks/state-provider'
import {isShareOptionsVisible} from '../../selectors/single-settings'
import {SocialBarProps} from './interfaces'

export const SocialBar = ({event, hideTitle: hideTitleOverride, ...props}: SocialBarProps) => {
  const {pageUrl, builderPageUrl} = useWidgetRuntimeContext()
  const eventUrl = useWidgetState(state =>
    event.eventPageUrl?.base
      ? getEventPageUrl(event)
      : getEventUrl(builderPageUrl?.url ?? pageUrl.url, event, state.multilingual),
  )
  const hideTitle = useWidgetState(state => isEventsInMembersInstalled(state) || hideTitleOverride)
  const {shareEvent} = useWidgetActions()

  return (
    <SocialBarCommons
      eventUrl={eventUrl}
      hideTitle={hideTitle}
      onShare={(eventId, buttonName) => shareEvent({eventId, buttonName})}
      eventId={event.id}
      {...props}
    />
  )
}

export const SingleEventSocialBar = (props: SocialBarProps) => {
  const shareOptionsVisible = useWidgetState(isShareOptionsVisible)

  return shareOptionsVisible ? <SocialBar {...props} /> : null
}
